import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
var _excluded = ["withCustomPagination"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/* eslint-disable react/prop-types */
import React from 'react';
import { AgGridDefault } from "./AgGridDefault";
import { AgGridPaginated } from "./AgGridPaginated";
import '@ag-grid-community/core/dist/styles/ag-grid.css';
import '@ag-grid-community/core/dist/styles/ag-theme-alpine.css';
import "./styles.css";
import { LicenseManager } from '@ag-grid-enterprise/core';
LicenseManager.setLicenseKey('CompanyName=ApplyBoard Inc,LicensedApplication=ApplyBoard,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=5,LicensedProductionInstancesCount=1,AssetReference=AG-010866,ExpiryDate=30_September_2021_[v2]_MTYzMjk1NjQwMDAwMA==2fa05040a6ad04fd7a624cd718d5b250');
export function AgGrid(_ref) {
  var _ref$withCustomPagina = _ref.withCustomPagination,
    withCustomPagination = _ref$withCustomPagina === void 0 ? false : _ref$withCustomPagina,
    props = _objectWithoutProperties(_ref, _excluded);
  return withCustomPagination ? /*#__PURE__*/React.createElement(AgGridPaginated, props) : /*#__PURE__*/React.createElement("div", {
    className: "ag-theme-alpine",
    style: {
      height: '100%',
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(AgGridDefault, props));
}